import { ProgressMode } from './surveyCollector/surveyProgress';

export default {
  progress: {
    mode: 'full' as ProgressMode,
  },
};
